import React from 'react'
import { connect } from 'react-redux'
import Loading from 'discada/dist/Loading'
import c from 'classnames'
import isEmpty from 'lodash/isEmpty'
import uuid from 'uuid/v1'

import { getUser, getIsLoggedIn } from 'selectors/authSelectors'
import { getRouteWithRooftop } from 'selectors/pageStateSelectors'
import {
  goTo,
  redirect,
  removeFromPageState,
  addToPageState,
} from 'actions/pageStateActions'
import { proxyRequest } from 'actions/apiActions'
import { signOut, updateAuth } from 'actions/authActions'
import { CustomScripts } from 'components/widgets/CustomScripts'

import {
  warn,
  setupMessenger,
  teardownMessenger,
  makeStaticAssetPath,
} from 'utils'

import './mportal.scss' // only needed for MportalSettings

export class MportalSettings extends React.Component {
  state = {
    loaded: false,
  }

  componentWillMount() {
    document.body.className +=
      'header-fixed sidebar-fixed sidebar-hidden aside-menu-fixed aside-menu-hidden mportal-fence'

    window.__frikinAPI = this.props.proxyRequest

    this.checkDom = () => {
      if (!isEmpty(document.querySelector('.mportal-app .app')))
        this.setState({ loaded: true })
      else setTimeout(this.checkDom, 1)
    }
  }

  componentDidMount() {
    this.checkDom()
  }

  render() {
    if (!this.props.isLoggedIn) return null

    let { loaded } = this.state

    const MPORTAL_JS = [
        {
          name: 'mportal-vue-js',
          body: `<script src="${makeStaticAssetPath(
            'mportal/js/app.js',
          )}"></script>`,
        },
      ],
      MPORTAL_STYLES = [
        {
          name: 'mportal-vue-css',
          body: `<link href="${makeStaticAssetPath(
            'mportal/css/app.css',
          )}" rel="stylesheet" />`,
        },
      ]

    return (
      <>
        <div className={c('mportal-app', { loaded })}>
          <div id="app">
            <Loading />
          </div>
        </div>
        {false && (
          <CustomScripts scripts={MPORTAL_JS} styles={MPORTAL_STYLES} />
        )}
      </>
    )
  }
}

let askChildToSendNewSize = frameId => {
  let frame = document.getElementById(frameId)

  if (!frame) return

  frame.contentWindow.postMessage({ message: 'resize' }, window.location.origin)
}

export class SimpleAppFrame extends React.Component {
  state = {}

  componentWillMount() {
    this.props.updateAuth().then(() => this.setState({ authUpdated: true }))
  }

  componentDidMount() {
    let { frameId } = this.props,
      frikinAPI = ({ path, method, body = {} }) => {
        frameId
          ? this.props
              .proxyRequest(path, { method }, JSON.parse(body))
              .then(response =>
                document
                  .getElementById(frameId)
                  .contentWindow.postMessage(
                    { path, response: JSON.stringify(response) },
                    window.location.origin,
                  ),
              )
              .catch(e => console.error(e))
          : warn('frameId not set, aborting')
      }

    setupMessenger()

    window.__frikinAPI = frikinAPI

    window.__frikin = {
      goTo: this.props.goTo,
      addToPageState: params => this.props.addToPageState(JSON.parse(params)),
      removeFromPageState: params =>
        this.props.removeFromPageState(JSON.parse(params)),
      signOut: message => this.props.signOut(message),
      redirect: this.props.redirect,
      api: frikinAPI,
      resize: contentHeight => {
        let frame = document.getElementById(frameId)

        if (frame && this.props.resize) {
          frame.style.height = [contentHeight + 1, 'px'].join('')
        }
      },
    }

    //when the parent window changes size, ask for an updated value from the child
    window.addEventListener('resize', () => askChildToSendNewSize(frameId))

    askChildToSendNewSize(frameId)
  }

  componentWillUnmount() {
    teardownMessenger()
    window.removeEventListener('resize', askChildToSendNewSize)
  }

  render() {
    let {
        title,
        src,
        style = {},
        authRequired,
        isLoggedIn,
        frameId,
        scrolling = 'yes',
      } = this.props,
      { authUpdated } = this.state

    if (!authUpdated) return null

    if (authRequired && !isLoggedIn) return null

    return (
      <iframe
        id={frameId}
        title={title}
        src={src}
        style={{
          border: '0',
          padding: '0',
          margin: '0',
          overflow: 'hidden',
          width: '100%',
          height: '100vh',
          ...style,
        }}
        scrolling={scrolling.toString()}
      />
    )
  }
}

function mapStateToProps(state, op) {
  return {
    frameId: op.frameId || uuid(),
    resize: true,
    ...op,
    isLoggedIn: getIsLoggedIn(state),
    src: getRouteWithRooftop(state, op.src),
    getUser: () => getUser(state),
  }
}

export default connect(
  mapStateToProps,
  {
    proxyRequest,
    goTo,
    redirect,
    signOut,
    removeFromPageState,
    addToPageState,
    updateAuth,
  },
)(MportalSettings)

export const AppFrame = connect(
  mapStateToProps,
  {
    proxyRequest,
    goTo,
    redirect,
    signOut,
    removeFromPageState,
    addToPageState,
    updateAuth,
  },
)(SimpleAppFrame)
